import React from 'react';
import { Grid, Tabs, Tab, Button, CircularProgress } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import FilterComponent from '../../../../shared_elements/filter_component';
import { SectionCard, SPACE } from '../../shared_components';
import { STATUS_OPTIONS, STATUS_TAB_COUNT_KEYS } from '../constants';

const tabLabel = (label, count) => (count === undefined || count === null ? label : `${label} (${count})`);

const PlannerToolbar = ({
  tab, onChangeTab, filter, filterMenu, onApplyFilter,
  canCreate, onAddPlan, onExport, exporting = false, resultCount, tabCounts = {},
}) => (
  <div>
    <SectionCard noPadding style={{ marginBottom: SPACE.md }}>
      <Tabs
        variant="fullWidth"
        scrollButtons="auto"
        value={tab}
        onChange={(event, value) => onChangeTab(value)}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab value="all" label={tabLabel('All', tabCounts?.all)} />
        {STATUS_OPTIONS.map((status) => (
          <Tab key={status?.id} value={status?.label || ''} label={tabLabel(status?.label, tabCounts?.[STATUS_TAB_COUNT_KEYS[status?.label]])} />
        ))}
      </Tabs>
    </SectionCard>

    <Grid container spacing={2} alignItems="center">
      <Grid item>
        <FilterComponent filter={filter} filterMenu={filterMenu} getResponseBack={onApplyFilter} />
      </Grid>
      <Grid item style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: SPACE.sm }}>
        <Button
          size="small" variant="outlined"
          startIcon={exporting ? <CircularProgress size={14} /> : <SaveAltIcon fontSize="small" />}
          disabled={!resultCount || exporting} onClick={onExport}
        >
          Export
        </Button>
        {canCreate ? (
          <Button size="small" variant="contained" color="primary" startIcon={<AddIcon fontSize="small" />} onClick={onAddPlan}>
            Add Plan
          </Button>
        ) : null}
      </Grid>
    </Grid>
  </div>
);

export default PlannerToolbar;
